import { __exports as e } from "./index127.js";
var r;
function s() {
  if (r) return e;
  r = 1, Object.defineProperty(e, "__esModule", { value: !0 });
  var t = /.+\@.+\..+/;
  function i(a) {
    return t.test(a);
  }
  return e.default = i, e;
}
export {
  s as __require
};
//# sourceMappingURL=index117.js.map
